export default __webpack_public_path__ + "static/freedom-debt-relief-c6b8f6d502e062960e8722bf3935faa4.png";